var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMember)?_c('v-btn',{staticClass:"text-capitalize",attrs:{"rounded":"","depressed":"","small":"","color":"#E4E6EB"},on:{"click":_vm.signMember}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-wallet-membership")]),_c('span',[_vm._v("Member")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }